"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Check if the value is an Array
 *
 * @param param Value to be checked
 * @returns {boolean} Returns true when the `param` is an Array
 *
 * @example
 * isArray([]); // Returns: true
 * isArray({}); // Returns: false
 * isArray('Hello'); // Returns: false
 */
exports.default = Array.isArray;
//# sourceMappingURL=isArray.js.map


//////////////////
// WEBPACK FOOTER
// ./~/d2-utilizr/lib/isArray.js
// module id = 360
// module chunks = 0